import MuiAlert, {AlertProps} from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import React from 'react'

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

interface IProps {
  customMessage?: string
  isOpen: boolean
  setIsSnackbarOpen: (value: boolean) => void
  severity?: 'error' | 'warning' | 'info' | 'success'
  autoHideDuration?: number
}

export default function ReusableSnackbar({
  customMessage,
  isOpen,
  setIsSnackbarOpen,
  severity = 'error',
  autoHideDuration = 3000,
}: IProps) {
  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }
    setIsSnackbarOpen(false)
  }

  // Default messages based on severity
  const getDefaultMessage = () => {
    switch (severity) {
      case 'success':
        return 'Operation completed successfully!'
      case 'warning':
        return 'Please review your input and try again.'
      case 'info':
        return 'Information has been updated.'
      case 'error':
      default:
        return 'Something went wrong, please contact your Administrator'
    }
  }

  return (
    <Snackbar
      data-testid={`snackbar-${severity}-${
        customMessage?.length ? customMessage : getDefaultMessage()
      }`}
      aria-label={`snackbar-${severity}-${
        customMessage?.length ? customMessage : getDefaultMessage()
      }`}
      open={isOpen}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
      sx={{
        maxWidth: '500px',
        '@media (max-width: 900px)': {
          maxWidth: '250px',
        },
      }}>
      <Alert
        data-testid={`snackbar-alert-${severity}-${
          customMessage?.length ? customMessage : getDefaultMessage()
        }`}
        aria-label="snackbar-alert"
        onClose={handleClose}
        severity={severity}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxHeight: 60,
          alignItems: 'center',
          maxWidth: '500px',
          '@media (max-width: 900px)': {
            maxWidth: '250px',
          },
        }}>
        {customMessage?.length ? customMessage : getDefaultMessage()}
      </Alert>
    </Snackbar>
  )
}
